import app from "@/services/localStorage/app";

export default {
  install(Vue, options = {}) {
    if (!Vue.Echo) {
      console.error("RouterReloader requires the Echo plugin.");
      return;
    }

    if (!options.router) {
      console.error("RouterReloader requires a router instance");
    }

    // Deployment listener
    Vue.Echo.channel("deployments").listen("NewDeployment", () => {
      app.setOutdated();
    });

    // Add a global beforeEach
    options.router.beforeEach((to, from, next) => {
      if (!app.getOutdated()) {
        return next();
      }

      app.setUpToDate();

      let base = options.router.options.base;

      if (!_.startsWith(base, "/")) {
        base = "/" + base;
      }

      window.location = window.location.origin + base + to.fullPath;
    });
  }
};
